import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const fetchAccountDetails = async (
  appName: string,
  accountName: string
) => {
  try {
    const url = `${urls.GET_ACCOUNT_DETAILS}/app/${appName}/name/${accountName}`;
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateAccountDetails = async (
  accountDetais: any,
  accountName: string
) => {
  try {
    const url = `${urls.UPDATE_ACCOUNT}/${accountName}`;
    const callParams = await getCallParams("PATCH", accountDetais);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
